import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import {ApiBaseUrl} from '../../../constants';
import { AuthContext } from "./../../../context/auth";
import Deal from './Deal';
import { trackPromise } from 'react-promise-tracker';
import {withSnackbar} from "react-simple-snackbar";

class MyPurchased extends Component{
    static contextType = AuthContext;
    state = {
        data:[],
        hasMoreItems: true,
        page: 1
    }

    shouldComponentUpdate(nextProps, nextState) {
        document.getElementById('body').className='my-purchased pagi-page'
        if(nextState.page !== this.state.page)
            return true;
        else
            return false;
    }

    loadItems(page) {
        page=this.state.page;
        var url = ApiBaseUrl+'/consumer/allday/purchased_deals/?page='+page;
        trackPromise(
        fetch(url,{
            method: 'GET',
            headers:
                {
                    "Authorization": "Bearer "+this.context.token
                }
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if(!result.success)
                        this.props.openSnackbar(result.message)
                    else {
                        result.data.map(deal => (
                            this.state.data.push(deal)
                        ));

                        if (result.data.length > 0) {
                            this.setState({hasMoreItems: true, page: this.state.page + 1})
                        }
                        else
                            this.setState({hasMoreItems: false})
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        hasMoreItems: false
                    });
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        document.getElementById('body').className='my-purchased'
    }
    componentWillUnmount () {
        document.getElementById('body').className=''
    }

    render(){
        var deals = [];
        if(this.state.data.length===0) {
            deals = (<div className="col-12 text-center text-white">
                You don't have any deals yet
            </div>)
        }
        else{
            this.state.data.map( deal => (
                deals.push(
                    <Deal key={deal._id} deal={deal} />
                )
            ));
        }
        return(
            <React.Fragment>
                <div className="overlay"></div>
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container ux-grid">
                    <div className="row">
                        <InfiniteScroll className="purchased-deal-outer"
                            pageStart={1}
                            loadMore={this.loadItems.bind(this)}
                            hasMore={this.state.hasMoreItems}>
                            {deals}
                        </InfiniteScroll>
                    </div>
                </div>
            </div>
            </React.Fragment>
        )
    }
}

export default withSnackbar(MyPurchased,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});